import React, { Component, useMemo } from "react";

import DataTable from "../../_Components/DataTable";
import _ from "lodash";
import { Button } from "react-bootstrap";
import CardNumberFormat from "../../_Components/CardNumberFormat";

// import {Switch} from '@mui/material/Switch';
function DataGridAmusementServices({
  data,
  setShowModalAccount,
  setSelectedAccountId,
}) {
  // const handleChangeIsDefault = (name) => event => {
  //     callApiService(name,1);
  // }
  // async function callApiService(item,flag) {

  //     const response = await ApiPublicPromoCodeService.removePublicPromoCode({
  //         id: item.allPublicPromoCodeViewModel.id,
  //         Status: !item.allPublicPromoCodeViewModel.isDeleted
  //         });
  //     if (response.succeeded == true)
  //         (document.getElementById('submitButton')).click();

  //     SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  // }

  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "accountOwnerName",
        Header: "نام و نام خانوادگی",
        minWidth: "150px",
      },
      {
        accessor: "bank",
        Header: "نام بانک",
        minWidth: "100px",
      },
      {
        accessor: "accountNumber",
        Header: "شماره حساب",
        minWidth: "100px",
      },
      {
        accessor: "cardNumber",
        Header: "شماره کارت",
        minWidth: "200px",
        Cell: ({ row }) => (
          <CardNumberFormat number={row.original.cardNumber} />
        ),
      },
      {
        accessor: "shebaNumber",
        Header: "شماره شبا",
        minWidth: "100px",
      },
      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: "130px",
      },
      // {
      //     accessor: "status",
      //     Header: "وضعیت",
      //     Cell: ({ row }) => (
      //         <div className="text-center">

      //             <Switch
      //                 checked={row.original.status == 0 ? 1 : 1 }
      //                 //checked={state.checkedA}
      //                 value="row.original.status"
      //                 color="primary"
      //                 inputProps={{ 'aria-label': 'primary checkbox' }}

      //             />
      //         </div>
      //     )
      // },
      // {
      //     Header: 'عملیات',
      //     accessor: '',
      //     minWidth: 150,
      //     align: "center",
      //     Cell: ({ row }) => (
      //         <div className="text-center">
      //             {/* ویرایش */}
      //             <Button
      //                 className="btn btn-light-info btn-sm mr-2 btn-icon"
      //                 onClick={() => {
      //                     setSelectedAccountId(row.original.id);
      //                     setShowModalAccount(true);
      //                 }}
      //             >
      //                 <i className='far fa-edit text-small'></i>
      //             </Button>
      //         </div>
      //     )
      // }
    ],
    []
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridAmusementServices;
